import React, { useEffect } from 'react';

const ServerAutopsy = () => {
  React.useEffect(() => {
    // eslint-disable-next-line no-console
    console.warn('Placeholder: ServerAutopsy is not implemented yet.');
  }, []);
  return (
    <>
  { /*ServerAutopsy */} 
 </>
  );
};

export default ServerAutopsy;
